import { render, staticRenderFns } from "./audiobook-chapters-editor.vue?vue&type=template&id=64464ce6&scoped=true&"
import script from "./audiobook-chapters-editor.vue?vue&type=script&lang=ts&"
export * from "./audiobook-chapters-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64464ce6",
  null
  
)

export default component.exports